import type { SEARCH_SITE_TABLE_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/search-site-table/search-site-table.fr.ts";

export const SEARCH_SITE_TABLE_ENGLISH_LOCALE = {
  search: "Search",
  empty: "No site found, try to modify filters",
  headers: {
    siteId: "Site Id",
    subscriberFirstname: "First name",
    subscriberLastname: "Last name",
    siteAddress: "Address",
    sitePostalCode: "Postal Code",
    siteCity: "City",
    country: "Country",
  },
} satisfies typeof SEARCH_SITE_TABLE_FRENCH_LOCALE;
